module.exports = __webpack_public_path__ + "img/hzkh3.24b8770a.jpg";